import React, { useEffect, useState } from 'react';
import './AssetPicker.css';
import closeIcon from '../assets/icons/icon_close1.svg';
import KeyboardDoubleArrowLeftOutlinedIcon from '@mui/icons-material/KeyboardDoubleArrowLeftOutlined';
import KeyboardDoubleArrowRightOutlinedIcon from '@mui/icons-material/KeyboardDoubleArrowRightOutlined';
import KeyboardArrowLeftOutlinedIcon from '@mui/icons-material/KeyboardArrowLeftOutlined';
import KeyboardArrowRightOutlinedIcon from '@mui/icons-material/KeyboardArrowRightOutlined';
import Search from '../assets/images/Search.png';

const AssetPicker = () => {
  const [allAssets, setAllAssets] = useState([]);
  const [assets, setAssets] = useState([]);
  const [field1, setField1] = useState('Asset No');
  const [operator1, setOperator1] = useState('like');
  const [value1, setValue1] = useState('');
  const [logic, setLogic] = useState('AND');
  const [field2, setField2] = useState('Asset No');
  const [operator2, setOperator2] = useState('like');
  const [value2, setValue2] = useState('');

  useEffect(() => {
    const data = localStorage.getItem('assetPickerData');
    if (data) {
      const parsedData = JSON.parse(data);
      setAllAssets(parsedData);
      setAssets(parsedData);
    }
  }, []);

  const getFieldValue = (asset, field) => {
    switch(field) {
      case 'Asset No': return asset.lad_Equip || '';
      case 'Asset Type': return asset.lad_E_Type_Desc || '';
      case 'Asset Sub Type': return asset.lad_E_Subtype_Desc || '';
      case 'Username': return asset.username || '';
      default: return '';
    }
  };

  const matchesFilter = (asset, field, operator, value) => {
    if (!value) return true;
    const fieldValue = getFieldValue(asset, field).toLowerCase();
    const searchValue = value.toLowerCase();
    
    switch(operator) {
      case 'like': return fieldValue.includes(searchValue);
      case 'contains': return fieldValue.includes(searchValue);
      case 'equal': return fieldValue === searchValue;
      default: return true;
    }
  };

  const handleSearch = () => {
    const filtered = allAssets.filter(asset => {
      const match1 = matchesFilter(asset, field1, operator1, value1);
      const match2 = matchesFilter(asset, field2, operator2, value2);
      
      if (logic === 'AND') {
        return match1 && match2;
      } else {
        return match1 || match2;
      }
    });
    setAssets(filtered);
    
  };

  const handleAssetSelect = (assetNo) => {
    window.opener.postMessage({ type: 'ASSET_SELECTED', assetNo }, window.location.origin);
    window.close();
  };

  return (
    <div className='picker-container'>
      <div className='picker-header'>
        <h2>Select Asset</h2>
        <div className='picker-icons'>
          <KeyboardDoubleArrowLeftOutlinedIcon className='move-icon' sx={{color: 'rgba(140, 140, 140, 1)', fontSize: '18px'}}/>
          <KeyboardArrowLeftOutlinedIcon className='move-icon' sx={{color: 'rgba(140, 140, 140, 1)', fontSize: '18px'}}/>
          <KeyboardArrowRightOutlinedIcon className='move-icon' sx={{color: 'rgba(140, 140, 140, 1)', fontSize: '18px'}}/>
          <KeyboardDoubleArrowRightOutlinedIcon className='move-icon' sx={{color: 'rgba(140, 140, 140, 1)', fontSize: '18px'}}/>
          <img src={closeIcon} alt='Close' onClick={() => window.close()} className='close-icon'/>
        </div>
      </div>

      <table className='picker-table'>
        <thead>
          <tr>
            <th>Asset No</th>
            <th>Asset Type</th>
            <th>Asset Subtype</th>
            <th>Username</th>
            <th>Company</th>
          </tr>
        </thead>
        <tbody>
          {assets.map((asset, index) => (
            
            <tr key={index} onClick={() => handleAssetSelect(asset.lad_Equip)}>
              <td className='asset-no-cell'>{asset.lad_Equip}</td>
              <td>{asset.lad_E_Type_Desc}</td>
              <td>{asset.asset_sub_type}</td>
              <td>{asset.users}</td>
              <td>{asset.comp}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className='filter-section'>
        <table className='filter-table'>
        <tbody>
          <tr>
            <td>
              <select value={field1} onChange={(e) => setField1(e.target.value)} className='filter-select'>
                <option>Asset No</option>
                <option>Asset Type</option>
                <option>Asset Sub Type</option>
                <option>Username</option>
              </select>
            </td>
            <td>
              <select value={operator1} onChange={(e) => setOperator1(e.target.value)} className='filter-select'>
                <option value='like'>like</option>
                <option value='contains'>contains</option>
                <option value='equal'>equal to</option>
              </select>
            </td>
            <td>
              <input type='text' value={value1} onChange={(e) => setValue1(e.target.value)} className='filter-input'/>
            </td>
          </tr>
          <tr>
            <td colSpan='2'>
              <select value={logic} onChange={(e) => setLogic(e.target.value)} className='filter-select'>
                <option>AND</option>
                <option>OR</option>
              </select>
            </td>
            <td>
              <button className='search-btn' onClick={handleSearch}><img src={Search} alt='Search'/></button>
            </td>
          </tr>
          <tr>
            <td>
              <select value={field2} onChange={(e) => setField2(e.target.value)} className='filter-select'>
                <option>Asset No</option>
                <option>Asset Type</option>
                <option>Asset Sub Type</option>
                <option>Username</option>
              </select>
            </td>
            <td>
              <select value={operator2} onChange={(e) => setOperator2(e.target.value)} className='filter-select'>
                <option value='like'>like</option>
                <option value='contains'>contains</option>
                <option value='equal'>equal to</option>
              </select>
            </td>
            <td>
              <input type='text' value={value2} onChange={(e) => setValue2(e.target.value)} className='filter-input'/>
            </td>
          </tr>
        </tbody>
        </table>
      </div>
    </div>
  );
};

export default AssetPicker;
